<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12oKuYk/tc-custom/9781667456911.jpg?1686492739770" alt="This image is the cover for the book Obras Maestras de Malicia 6, Malicia"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Obras Maestras de Malicia 6, Malicia
      </h1>
      <p class="bookDescription body article font2">
        <p>Malicia Metódica (Libro 26)<br/> Seguir adelante después de que termina un largo matrimonio es matador y encontrar y decorar un nuevo hogar no es algo que Alice disfrute. Ella se siente molesta por los inconvenientes causados por aquellos que la vigilan a ella y a su nueva vida. Ella está recomponiendo metódicamente su vida, pero cuando finalmente comienza a poner sus cosas en orden, la vida le lanza una bola difícil que nadie podría haber visto venir.<br/> Malicia Malévola (Libro 27)<br/> El accidente de Alice pone una inmensa tensión en la dinámica familiar que nadie podría haber anticipado. Su impacto de largo alcance alterará a su familia en más de una forma.<br/> Malicia Militar (Libro 28)<br/> Los asuntos pendientes de Alice le han causado a ella y a su familia muchas molestias imprevistas, y Alice busca hacer las paces. Pero parece que la vida no ha terminado con ella todavía. ¡Justo cuando Alice piensa que van a ser felices de nuevo, la vida le lanza una curva más, y esta es extraordinaria!<br/> Malicia Maquiavélica (Libro 29)<br/> Cuando tu vida es un desastre, y estás rodeado de enemigos, ¿cómo combates las probabilidades abrumadoras en tu contra? Alice y Kathy deben enfrentar más que problemas de salud; las precupaciones de la vida y una letanía de agravios se acumulan en contra de ellas.<br/> Malicia Maléfica (Libro 30)<br/> Lecciones sobre cómo hacer enojar a una asesina serial lesbiana:<br/> 1) Golpéala en la cabeza con la culata de un arma.<br/> 2) Trátala con desdén y subestima sus habilidades.<br/> 3) ¡Involucra a su familia!<br/> Alice se despierta para descubrir que ha sido hecha prisionera. Los flashbacks son instantáneos, y cuando se da cuenta de que Kathy y Emily también están ahí, ella se ve obligada a devolverlas a la seguridad. Alice no quiere que su familia se involucre en esta parte de su vida. Ella no se siente cómoda con que ellos sepan, mucho menos que partici</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        K'Anne Meinel, Adriana Boccaloni
      </h2>
      
      <p class="authorDescription body article">K'Anne Meinel es una escritora de ficción prolífica, más vendida y galardonada con más de cien obras publicadas que incluyen cortometrajes, novelas y novelas.<br/> K'Anne Meinel es una autora estadounidense de Wisconsin, nacida en Milwaukee y criada fuera de Oconomowoc. Después de graduarse temprano en la escuela secundaria, asistió a una universidad privada en Milwaukee y luego se mudó a California.<br/> Muchas de las historias de K'Anne han sido elogiadas pr su autenticidad, antecedentes maravillosamente detallados e historias convincentes. Llamada la Danielle Steel de su tiempo, continúa escribiendo historias convincentes en una variedad de géneros de ficción. Puede obtener más información en www. kannemeinel.com<br/> Síguela... ¡nunca se sabe qué se le ocurrirá a K'Anne a continuación!<br/></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Shadoe Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5636fea0